// Row 1.12 — app-bar contextual actions. Renders whatever the currently-mounted app registered via
// useShellStore's `appBarActions` (see shellStore.ts's own header comment on that slice). Renders
// nothing when empty — no live producer calls setAppBarActions yet (CFR-CHROME01-04), so this is
// inert in every mounted app today; the channel itself is real and tested.
import type { ReactElement } from "react";
import { useShellStore } from "../state/shellStore";

export function AppBarActions(): ReactElement | null {
  // Defaults to [] defensively: a test file that mocks useShellStore with a narrow selector shape
  // (e.g. TopNav.spec.tsx, which only provides `openCommandPalette`) would otherwise return
  // `undefined` here, not an empty array.
  const actions = useShellStore((s) => s.appBarActions) ?? [];
  if (actions.length === 0) return null;
  return (
    <div className="flex items-center gap-1" data-app="app-bar-actions">
      {actions.map((action, i) => (
        <span key={i}>{action}</span>
      ))}
    </div>
  );
}
